import { MoreVert } from "@mui/icons-material";
import { IconButton, Menu, MenuItem } from "@mui/material";
import React, { useRef, useState } from "react";

export interface CardProps {
  index?: number;
  bgImage?: string;
  icon?: string;
  title?: string;
  subTitle?: string;
  body?: React.ReactNode;
  footer?: React.ReactNode;
  menuItems?: {
    icon: React.ReactNode;
    label: string;
    onChange: (item: any, index: number) => void;
  }[];
}
export default function Card(props: CardProps) {
  const ref = useRef<any>(null);
  const [anchorEl, setAnchorEl] = useState<any>(null);
  return (
    <div
      className="bg-white shadow-[0_0_10px_0px_rgba(0,0,0,0.2)] rounded-md h-56 w-96 aspect-video flex flex-col justify-between bg-cover"
      style={{ backgroundImage: `url(${props.bgImage})` }}
      ref={ref}
    >
      <div>
        {/* Header */}
        <div className="flex items-center justify-between h-12 border-r-4 border-blue-1 rounded-[4px] ">
          <div className="flex items-center">
            <div className="text-base p-4">{props.index}</div>
            <div className="w-9 h-9 border border-gray-300 rounded-md flex items-center justify-center p-2">
              <img src={props.icon} alt="" className="w-full" />
            </div>
          </div>
          {props.menuItems && (
            <>
              <IconButton disableRipple onClick={(e) => setAnchorEl(e.currentTarget)}>
                <MoreVert
                  style={{
                    color: `${!Boolean(anchorEl) ? "#8f8f8f" : "#1062D0"}`,
                    transform: `${Boolean(anchorEl) ? "rotate(90deg)" : ""}`,
                    transition: "300ms",
                  }}
                />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                style={{ borderRadius: "4px" }}
                disableScrollLock
                MenuListProps={{ style: { padding: 0 } }}
                onClose={() => setAnchorEl(null)}
                transformOrigin={{ horizontal: "left", vertical: "top" }}
                anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
              >
                {props.menuItems?.map((item, i) => {
                  return (
                    <MenuItem
                      key={i}
                      style={{ direction: "rtl" }}
                      className="gap-2"
                      onClick={() => {
                        setAnchorEl(null);
                        item.onChange(item, i);
                      }}
                    >
                      <span className="w-5 flex items-center justify-center">{item.icon}</span>
                      <span className="text-xs text-gray-500">{item.label}</span>
                    </MenuItem>
                  );
                })}
              </Menu>
            </>
          )}
        </div>
        <div>
          {/* Title */}
          <div className="flex flex-col py-2 px-6 gap-2">
            <span className="text-xl text-dark-1">{props.title}</span>
            <span className="text-sm text-dark-3">{props.subTitle}</span>
          </div>
        </div>
      </div>
      <div>
        {/* Body */}
        <div>{props.body}</div>

        {/* Footer */}
        <div className="border-t border-gray-300 p-3">{props.footer}</div>
      </div>
    </div>
  );
}
